var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.items),function(item,index){return [_vm._l((item.codes),function(code,codeIndex){return [_c('receipt-card',{key:`${index}-${codeIndex}`,ref:"receiptCard",refInFor:true,staticClass:"pdf-item",attrs:{"package":_vm.package,"item":item,"code":code}})]})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }